export var TypeActionModal;
(function (TypeActionModal) {
    TypeActionModal["Open"] = "Modal > Open";
    TypeActionModal["Close"] = "Modal > Close";
    TypeActionModal["CloseAll"] = "Modal > CloseAll";
    TypeActionModal["CloseLast"] = "Modal > CloseLast";
    TypeActionModal["SwapLast"] = "Modal > Swap";
    TypeActionModal["TabSelect"] = "Modal > TabSelect";
})(TypeActionModal || (TypeActionModal = {}));
export var actionModalOpen = function (modalId) { return ({
    modalId: modalId,
    type: TypeActionModal.Open,
}); };
export var actionModalClose = function (modalId) { return ({
    modalId: modalId,
    type: TypeActionModal.Close,
}); };
export var actionModalCloseAll = function (modalType) { return ({
    modalType: modalType,
    type: TypeActionModal.CloseAll,
}); };
export var actionModalCloseLast = function (modalId, modalType) { return ({
    modalId: modalId,
    modalType: modalType,
    type: TypeActionModal.CloseLast,
}); };
export var actionModalSwapLast = function (modalId) { return ({
    modalId: modalId,
    type: TypeActionModal.SwapLast,
}); };
// TODO: Should ideally be moved to separate menu component
export var actionModalTabSelect = function (tabId) { return ({
    tabId: tabId,
    type: TypeActionModal.TabSelect,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/modals/actionModal.ts
// module id = 8
// module chunks = 3